import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/system';
import colors from '../../assets/colors';

const RedCancelIcon = styled(CancelIcon)({
  color: colors.redButton,
});

export default RedCancelIcon;
